<div class="h-100 d-flex align-items-center" *appHasRole="['Admin', 'Manager', 'Preparer']">
  <app-ag-action-icon-button
    iconClass="ic-edit-16"
    tooltipText="Edit"
    (action)="editTag()"
  />

  <app-ag-action-icon-button
    iconClass="ic-close-16"
    tooltipText="Delete"
    (action)="deleteTag()"
  />
</div>
